<div class="text-message flex flex-col justify-center items-center space-y-6 h-full p-[2rem]">
  <div class="image">
    <app-image
      [loaderTheme]="{
               'height': '100%',
               'width': '100%'
              }"
      [url]="'/assets/images/png/pageNotFound.png'"
      class="image-container"
    ></app-image>
  </div>

  <div class="text"> OOPS!...</div>
  <div class="message text-cool-grey">The page you were looking for doesn't exist</div>
  <app-primary-button
    class="back-button w-[40%]"
    type="small"
    (handleClick)="homepage()"
  >
    Go back
  </app-primary-button>

</div>
